import { render, staticRenderFns } from "./AlertSettingsButton.vue?vue&type=template&id=4007de0a&"
import script from "./AlertSettingsButton.vue?vue&type=script&lang=js&"
export * from "./AlertSettingsButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports